export default __webpack_public_path__ + "static/media/calendar.07df116a.svg";